import { createGlobalStyle } from 'styled-components'
import { ImageGradient } from '../../assets';
import { COLOR } from '../constants/constants';

export const GlobalStyle = createGlobalStyle`

    @font-face {
        font-family: 'Amorim Sans';
        font-style: normal;
        font-weight: 400;
        src: url('./fonts/AmorimLogo-Regular.eot');
        src: local('Amorim Sans'),
        url('./fonts/AmorimLogo-Regular.eot?#iefix') format('embedded-opentype'),
        url('./fonts/AmorimLogo-Regular.woff2') format('woff2'),
        url('./fonts/AmorimLogo-Regular.woff') format('woff'),
        url('./fonts/AmorimLogo-Regular.ttf') format('truetype')
    }
    
    @font-face {
        font-family: 'Amorim Sans Book';
        font-style: normal;
        font-weight: 400;
        src: url('./fonts/AmorimSans-Book.eot');
        src: local('Amorim Sans Book'),
        url('./fonts/AmorimSans-Book.eot?#iefix') format('embedded-opentype'),
        url('./fonts/AmorimSans-Book.woff2') format('woff2'),
        url('./fonts/AmorimSans-Book.woff') format('woff'),
        url('./fonts/AmorimSans-Book.ttf') format('truetype')
    }

    @font-face {
        font-family: 'Amorim Sans Serif';
        font-style: normal;
        font-weight: 400;
        src: url('./fonts/AmorimSerif-Book.eot');
        src: local('Amorim Sans Serif'),
        url('./fonts/AmorimSerif-Book.eot?#iefix') format('embedded-opentype'),
        url('./fonts/AmorimSerif-Book.woff2') format('woff2'),
        url('./fonts/AmorimSerif-Book.woff') format('woff'),
        url('./fonts/AmorimSerif-Book.ttf') format('truetype')
    }
    
    * { 
        margin: 0; 
        padding: 0;
    }
    *::-webkit-scrollbar { width: 2px } *::-webkit-scrollbar-track { background: #E2E2E2 } *::-webkit-scrollbar-thumb { background: #707070 }
    * { scrollbar-color: #E2E2E2 transparent; scrollbar-width: thin; }

    html, body {
        font-family: 'Amorim Sans Book', 'Serif';
        height:100vh;
    }
    body {
        background: ${COLOR.tertiaty};
    }
    .fullscreen{ 
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        overflow: hidden;
    }
    .gradient-fullscreen{
        position: absolute;
        top: 0;
        left: 0;
        z-index:1;
        pointer-events: none;
        touch-action: none;
        max-width:100vw;
        max-height: 100vh;
        width:100vw;
        height: 100vh;
        opacity: .35;
        background: url(${ImageGradient}) no-repeat;
        background-size: 100% 100%;
    }

    .force-transition3d{
        @media (max-width: 767px) {
            position: absolute;
            top: calc(100vh - 130px) !important;
            left: 48% !important;
            transform: translateX(0) !important;
        }
        @media (min-width: 768px) {
            /* transform: translate3d(960px, 765px, 0px) !important; */
            position: absolute;
            top: calc(100vh - 166px) !important;
            left: 50% !important;
            transform: translateX(0) !important;
        }
    }

    @media (max-width: 767px) {
        .gradient-fullscreen{
            position: absolute;
            top: 0;
            left: 0;
            z-index:1;
            pointer-events: none;
            touch-action: none;
            max-width:100vw; 
            max-height: 100vh;
            width:100vw; 
            height: 100vh; 
            opacity: .2;
            background: url(${ImageGradient}) no-repeat;
            background-size: 100% 100%;
        }
    }
    .no-touch{
        pointer-events: none;
        touch-action: none;
    }
    .not-interact{
        pointer-events:none; 
        user-select: none;
    }
    .zindex--1{
        z-index:-1;
    }
    .zindex-10{
        z-index:10;
    }

    .product-arrow{ 
        color:#CCCCCC;
        height:32px;
        width:32px;
        font-size:32px;
    }
    .panorama-arrow{ 
        color:#FFFFFF;
        height:18px;
        width:18px;
        font-size:14px;
        line-height: 0.8;

        @media (min-height: 768px) {
            height:14px;
            width:14px;
        }
    }
    .panorama-button{
        width: 100%;
        max-width: 200px;
        height:40px;
        margin-left: 50px;
        margin-right: 50px;
        .label{
            font-size: 10px;
        }
        &.mobile{
            padding: 5px;
            width: 44px !important; 
            height: 44px !important;
            font-size: 11px; 
            word-break: break-all;
            margin-left: 0px;
            margin-right: 0px;
        }

        @media (min-width: 768px) {
            margin-left: 74px;
            margin-right: 74px;
        }
    }
    .svg-pro {
        width: 1.25em;
        overflow: visible;
        display: inline-block;
        font-size: inherit;
        height: 1em;
        overflow: visible;
        vertical-align: -0.125em;
        color: #FFF;
    }

    .title-component {
        position: absolute;
        top: 0;
        transform: translateY(14px);
        font-size: 18px;
        text-transform: uppercase;
        letter-spacing: .9px;
        font-weight: bold;
        transition: all .3s ease-in-out;
        white-space: nowrap;
        font-family: 'Amorim Sans Book';

        @media (min-width: 768px) {
            transform: translateY(12px);
            font-size: 11px;
        }

        @media (min-width: 768px) and (max-height: 700px){
            font-size: 11px;
        }
    }

    .description-component {
        position: relative;
        width: calc(100% - 80px);
        line-height: 17px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        transition: all .3s ease-in-out;

        @media (min-width: 768px) {
            width: 100%;
            opacity: 0;
        }
    }

    .description-menu-cards-component {
        margin-top: 10px;
        line-height: 20px;
        font-size: 16px;
        overflow: hidden;
        text-overflow: ellipsis;
        font-family: 'Amorim Sans Book', sans-serif;
        display: -webkit-box;
        transform: translateX(20px);
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        transition: all .3s ease-in-out;

        @media (min-width: 768px) {
            text-align: right;
            margin-top: 37px;
            left: 0;
            opacity: 1;
            transform: translateX(0px);
        }
    }

    .info-icon{
        position: relative;
        width: 100%;
        height: 100%;
        .hit {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: transparent;
        }

        .hotspot-description {
            position: absolute;
            top: 94%;
            left: 50%;
            transform: translateX(-50%);
            color: #FFF;
            font-size: 11px;
            letter-spacing: 1px;
            pointer-events: none;
            opacity: 0;
            transition: all .3s ease;
            white-space: nowrap;

            &.hovered {
                opacity: 1;
            }
        }
        &.video{
            &.open{
                z-index: 11;
            }
        }

        &.hovered{
            .circle-opacity{
                opacity: 0.5;
            }
        }

        &:hover{
            cursor:pointer;
        }
    }

    .z-index-3{
        z-index: 3;
    }

    .z-index-11{
        z-index: 11;
    }

    .pointer{cursor: pointer}
    .contact-title-component {
        color: #2D5A64;
        letter-spacing: 2px;
        padding: 0 15px;

        @media (min-width: 768px) {
            letter-spacing: 3px;
            padding: 0;
        }
    }

    .contact-form-button {
        &:hover {
            &:not(:disabled) {
                cursor: pointer;
                background: #1D3739;
                color: #FFF;
            }
        }
    }

    .contact-title-border-component {
        width: 100%;
        height: 20px;
        border-top: solid 1px #AFAEAE;
        letter-spacing: 1.28px;
        transition: all .3s linear;
        padding: 4px 4px 0 4px;

        &.filled {
            border-top: solid 1px #1A1919;
            color:#1A1919;
        }
    }

.garrafao{
    top: -20px;
    position: absolute;
    transform: translateX(-50%) scale(.65);

    @media (min-width: 768px) {
        transform: translateX(-50%) scale(1);
        top: -30px;
    }

    &.visible{
        display: block;
    }

    &.hidden{
        display: none;
    }
}

.ant-tooltip{
    font-size:12px;
}
.ant-tooltip-inner{
    font-family: 'Amorim Sans Book';
    min-width: 50px;
    min-height: 20px;
    padding: 0px 4px;
    text-align: center;
    color: #2D6455;
    background-color: #feffffdd;
}
.ant-tooltip-arrow-content{
    background-color: #feffffdd;
}

.cursor-pointer{
    cursor:pointer;
}

.animation-pulse{
    -webkit-animation: pulse 2.5s infinite  normal ease-out;
		animation: pulse 2.5s infinite  normal ease-out;
}

.active-hotspot-map{
   
        circle{
            stroke: #aedbd9;
            fill: #aedbd9;
            
            -webkit-animation: pulse2 2.5s infinite  normal ease-out;
            animation: pulse2 2.5s infinite  normal ease-out;
        }
}
`
